import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLString,
  GraphQLObjectType,
  GraphQLList
} from 'graphql'
import { ContrastQueryParameters } from '../endpoint-helpers'
import { Context } from '../shared'

interface Args {
  readonly organizationID: string
}

export const organizationApplicationTags: GraphQLFieldConfig<
  any,
  Context,
  Args
> = {
  description:
    'Get the set of tags used by all of the applications for a single organization.',
  type: new GraphQLObjectType({
    name: 'OrganizationApplicationTags',
    fields: () => ({
      tags: {
        type: new GraphQLNonNull(
          new GraphQLList(new GraphQLNonNull(GraphQLString))
        )
      }
    })
  }),
  args: {
    organizationID: {
      type: new GraphQLNonNull(GraphQLString)
    }
  },
  async resolve(_source, args, context): Promise<{ readonly tags: string[] }> {
    const { organizationID } = args
    const { connector } = context

    const params = new ContrastQueryParameters()
    params.append('expand', 'skip_links')

    return connector.get(`/${organizationID}/tags/applications/list?${params}`)
  }
}
